import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';

export default class EntryController extends AuthenticatedController {
  static post(widgetId, entry) {
    return super.post(APIRoutes.ENTRIES(widgetId), entry);
  }

  static put(widgetId, entry) {
    return super.put(`${APIRoutes.ENTRIES(widgetId)}/${entry.id}`, entry);
  }

  static delete(widgetId, id) {
    return super.delete(`${APIRoutes.ENTRIES(widgetId)}/${id}`);
  }
}
